import { render, staticRenderFns } from "./TitleBar.vue?vue&type=template&id=9f8761c4&scoped=true&"
import script from "./TitleBar.vue?vue&type=script&lang=ts&"
export * from "./TitleBar.vue?vue&type=script&lang=ts&"
import style0 from "./TitleBar.vue?vue&type=style&index=0&id=9f8761c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f8761c4",
  null
  
)

export default component.exports